import Vue from "vue";
import $ from 'jquery'
import { Component, Prop } from "vue-property-decorator";

@Component({
    name: 'ReferenceEditModal'
})
export default class ReferenceEditModal extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    reference!: string;

    openModal(): void {
        $('#' + this.modalId).modal('show');
    }

    closeModal(): void {
        $('#' + this.modalId).modal('hide');
    }

    private close(): void {

    }

    private save(): void {
        this.$emit('saved', this.reference);
    }
}